export default "__VITE_ASSET__71d1e9b0__"